module.exports = __webpack_public_path__ + "img/ru.7a8b3a7d.svg";